import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zh from './local/zh/translation';

let englishPromise: Promise<void> | undefined;

export function ensureLanguage(language: 'zh' | 'en') {
  if (language !== 'en' || i18n.hasResourceBundle('en', 'translation')) {
    return Promise.resolve();
  }
  englishPromise ??= import('./local/en/translation').then(({ default: translation }) => {
    i18n.addResourceBundle('en', 'translation', translation, true, true);
  });
  return englishPromise;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh',
    fallbackLng: 'zh',
    supportedLngs: ['zh', 'en'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    resources: {
      zh: { translation: zh },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
